/* eslint-disable no-param-reassign, max-params */

import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";

const initialState = {
  previewUrlAbortSignal: null,
  printableAreas: [],
  waitingForLoading: []
};

const creationModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    printableAreas: state => state.printableAreas
  },

  mutations: {
    abortPreviewUrl(state) {
      state.previewUrlAbortSignal?.abort();
      state.previewUrlAbortSignal = null;
    }
  },

  actions: {
    async fetchAreas({ rootGetters, state }, { productId, compositionId }) {
      if (state.waitingForLoading.includes(productId)) return new Promise(() => {}); // already loading

      let productArea = state.printableAreas.find(item => item.productId === productId);

      if (!productArea) {
        state.waitingForLoading = [...state.waitingForLoading, productId];
        const [response] = await api.printOnDemand.getPrintableAreas({
          product_id: productId
        });
        productArea = objNamesToCamelCase(response);
        state.printableAreas = [...state.printableAreas, productArea];
        state.waitingForLoading = state.waitingForLoading.filter(id => id !== productId);
      }

      const surfaceLabel = rootGetters["artwork/surfaceLabel"];
      const compositionArea = productArea.compositions.find(item => item.id === compositionId);
      const [area] = compositionArea.printableAreas[surfaceLabel];
      const surface = rootGetters["artwork/surface"];
      const artworkUrl = rootGetters["artwork/artworkUrl"];
      const size = rootGetters["artwork/artworkSize"];
      const scale = rootGetters["artwork/downscaleFactor"];
      const width = (size.width / scale / surface.ppi) * area.ppi;
      const height = (size.height / scale / surface.ppi) * area.ppi;

      return {
        width,
        height,
        artworkUrl,
        backdropUrl: area.imageUrl,
        rotation: area.rotationAngle,
        center: [area.x, area.y]
      };
    }
  }
};

export default creationModule;
